'use strict';

/*global blockElement*/
/*global unBlockElement*/
/*global services*/
/*global plugins*/
/*global regula*/
/*global isEmpty*/
/*global OpeningHours*/
/*global RegistrationProducts*/
/*global RegistrationParamsDefinition*/
/*global RegistrationItemsDefinition*/
/*global bulkEditItems*/
/*global demoItems*/

function Registration(containerID, initPrevalidate, step) {
    this.containerID = containerID;
    this.$container = null;

    this.products = null;
    this.paramsDefinition = null;
    this.itemsDefinition = null;
    this.itemsBulkTableLastIndex = 0;
    this.itemsBuldTableAddedManuf = [];

    this.changeInputAccountIcTimeout = 0;
    this.changeInputAccountIcDelay = 100;
    this.changeAccountTitleLock = false;
    this.step = 1;

    this.init(initPrevalidate, step);
}

Registration.prototype = $.extend({}, {
    construtor: 'Registration',

    //**************************************************************************

    registerCallbacks: function registerCallbacks() {
        var _this = this;
      
        _this.$container.on('change', '.form-input-account-ic', function () {
            var ic = $.trim($(this).val());

            if (!isEmpty(ic)) {
                _this.changeAccountIc(ic); 
            }
        });
      
        _this.$container.on('change', '.form-input-account-title, .form-input-account-domain-title', function () {
            var title = $.trim($(this).val());

            if (!isEmpty(title)) {
                _this.changeAccountDomain(title); 
            }
        });

        _this.$container.on('change', '.form-block__options input:radio', function () {
            _this.toggleFormBlockDefinition($(this).closest('.form-block__options'));
        });
            
        _this.$container.on('change', 'input[name=reservation_kind]:radio', function () {
            _this.changeAccountReservationKind(_this.$container.find('input[name=reservation_kind]:checked').val()); 
        });
            
        _this.$container.on('change', 'input.registation-step3-manuf-checkbox-input', function () {
            _this.changeManufacturerSelection($(this)); 
        });
            
        _this.$container.on('click', '#registration-step3-add-manuf', function () {
            _this.rentalsManufacturerAddNew(); 
        }); 
            
        _this.$container.on('click', '#registration-step3-clean-products', function () {
            _this.cleanProductsBulkTable(); 
        });   
            
        _this.$container.on('change', '#registration-step3-payment-online-before-cbx, .registration-step4-deposit-required-radio', function () {
            _this.changePaymentOnlineSelection(); 
        }); 
            
        _this.$container.on('change', '.registration-step4-guarantee-required-radio', function () {
            _this.changePaymentGuaranteeRequired(); 
            _this.changePricelistIntervalSet();
        });        
            
        _this.$container.on('change', '.registation-step4-pricelist-interval', function () {
            _this.changePricelistIntervalSet(); 
        });        
            
        _this.$container.on('change', '.registation-step4-pricelist-multidays', function () {
            _this.changePricelistMultidaysSet(); 
        }); 
            
        _this.$container.on('change', '.customization-color-preview input.customization-color-preview__radio', function () {
            _this.changeSettingsColorSchema(); 
        });  

        return _this;
    },

    //**************************************************************************

    setInputValue: function setInputValue(input, value) {
        var _this = this;

        if (value) {
            _this.$container.find(input).focus()
                                        .val(value)
                                        .change()
                                        .blur();
        }

        return _this;
    },

    changeAccountIc: function changeAccountIc(ic) {
        var _this = this;

        clearTimeout(_this.changeInputAccountIcTimeout);

        _this.changeInputAccountIcTimeout = setTimeout(function () {
            $.getCORS(services.get('configurations').param('DomainURL') + '/?action=utilities&method=js_load_data_by_ic&ic=' + ic, function (res) {
                try {
                    res = JSON.parse(res);
                    if(res.msg === 'SUCCESS') {
                        _this.changeAccountTitleLock = true;
                        _this.setInputValue('.form-input-domain', res.data.proposed_domain);
                        _this.setInputValue('.form-input-account-title', res.data.name);
                        _this.setInputValue('.form-input-account-street', res.data.address.street_name);
                        _this.setInputValue('.form-input-account-house-number', res.data.address.house_number);
                        _this.setInputValue('.form-input-account-city', res.data.address.city_name);
                        _this.setInputValue('.form-input-account-zipcode', res.data.address.zipcode);
                        if (res.data.DIC !== '') {
                          _this.setInputValue('.form-input-account-dic', res.data.DIC);
                          _this.$container.find('.form-input-account-vat_registered').prop('checked', true);
                          
                        }
                    }
                } catch(e) {
                    services.get('development').viewSiteErrorMsg(res, e);
                }
            });
        }, _this.changeInputAccountIcDelay);

        return _this;
    },

    changeAccountDomain: function changeAccountDomain(title) {
        var _this = this;
        
        if (_this.changeAccountTitleLock === true) {
          _this.changeAccountTitleLock = false;
          return;
        }

        clearTimeout(_this.changeInputAccountIcTimeout);

        _this.changeInputAccountIcTimeout = setTimeout(function () {
            $.getCORS(services.get('configurations').param('DomainURL') + '/?action=utilities&method=js_gen_domain_name_By_title&title=' + title, function (res) {
                try {
                    res = JSON.parse(res);
                    if(res.msg === 'SUCCESS') {
                        _this.setInputValue('.form-input-domain', res.data.proposed_domain);
                    }
                } catch(e) {
                    services.get('development').viewSiteErrorMsg(res, e);
                }
            });
        }, _this.changeInputAccountIcDelay);

        return _this;
    },

    toggleFormBlockDefinition: function toggleFormBlockDefinition($blockOptions) {
        var _this = this;

        var $blockDefinition = _this.$container.find('.form-block__definition[data-block="' + $blockOptions.data('block') + '"]');
        if ($blockDefinition.length) {
            var viewFormBlockDefinition = $blockOptions.find(':radio:checked').val() === '1';

            if (viewFormBlockDefinition) {
                _this.$container.find('.form-block__definition[data-block="' + $blockOptions.data('block') + '"]').slideDown();
            } else {
                _this.$container.find('.form-block__definition[data-block="' + $blockOptions.data('block') + '"]').slideUp();
            }
        }

        return _this;
    },
    
    changeAccountReservationKind: function changeAccountReservationKind($resKind) {
        var _this = this;

        if ($resKind === 'RENTAL') {
           _this.$container.find('.registration-first-step-registration-products-wrapper label').removeClass('disabled');
           _this.$container.find('.registration-first-step-registration-products-wrapper input').prop('disabled', false);
        } else {
           _this.$container.find('.registration-first-step-registration-products-wrapper label').addClass('disabled');
           _this.$container.find('.registration-first-step-registration-products-wrapper input').prop('disabled', true);
        }

        return _this;
    },
    
    rentalsManufacturerAddNew: function rentalsManufacturerAddNew() {
        var _this = this;
        
        var manufTemplateDom = _this.$container.find('.registation-step3-manuf-checkbox-template');
        var manufNewNode = manufTemplateDom.clone(true).removeClass('registation-step3-manuf-checkbox-template').show();
        var newManufInput = this.$container.find('#registration-new-manuf');
        if (newManufInput.val() !== '') {
          manufNewNode.find('.registation-step3-manuf-title').html(newManufInput.val());
          manufNewNode.find('input').val(newManufInput.val()).prop('checked', true);
          manufTemplateDom.parent().append(manufNewNode);
          bulkEditItems.bulkEditTable.handsontable.getCellMeta(0, 1).source.push(newManufInput.val());     
          
          newManufInput.val('');     
        }
        return _this;
    },
    
    changeManufacturerSelection: function changeManufacturerSelection($cbxChanged) { 
        var _this = this;
        
        if ($cbxChanged.prop('checked') === false) {
          return false;
        }
        
        var manufTitle = $cbxChanged.val();
        
        var pi;
        var ci;
        var anyFound = false;
        for(pi = 0; pi < demoItems.length; pi++) {
          var found = false;
          for(ci = 0; ci < demoItems[pi].length; ci++) {
            if (demoItems[pi][ci][1] === '107') {
              if (demoItems[pi][ci][2] === manufTitle) {
                found = true;
                anyFound = true;
              }  
            }          
          }                    
          
          var itemData = demoItems[pi];
          for(ci = 0; ci < demoItems[pi].length; ci++) {
            itemData[ci][0] = this.itemsBulkTableLastIndex;          
          }
                    
          if (found === true && this.itemsBuldTableAddedManuf.indexOf(manufTitle) === -1) {
            this.itemsBulkTableLastIndex++;
            bulkEditItems.bulkEditTable.handsontable.alter('insert_row', this.itemsBulkTableLastIndex, 1);        
            bulkEditItems.bulkEditTable.handsontable.setDataAtRowProp(itemData);
          }          
          
        }
        
        if (anyFound === true) {
            this.itemsBuldTableAddedManuf.push(manufTitle);
            _this.$container.find('#registration-step3-noitems-error').hide('fast');
            
            if (!_this.$container.find('#registration-step3-prepared-items-msg').is(':visible')) {        
                _this.$container.find('#registration-step3-prepared-items-msg').show('fast');
                setTimeout(function () {
                    _this.$container.find('#registration-step3-prepared-items-msg').hide('slow');
                }, 5000);            
            }
            
        }
     
        bulkEditItems.bulkEditTable.handsontable.render();
        
        return _this;
    },
    
    cleanProductsBulkTable: function cleanProductsBulkTable() {
        var _this = this;
     
        bulkEditItems.bulkEditTable.handsontable.updateSettings({ data: [] });
        this.itemsBulkTableLastIndex = 0;
        
        return _this;
    },
    
    changePaymentOnlineSelection: function changePaymentOnlineSelection() {
        var _this = this;
     
        var $paymentInput = _this.$container.find('#registration-step3-payment-online-before-cbx');
        var paymentDepositRequired = _this.$container.find('.registration-step4-deposit-required-radio:checked').val();
        
        if ($paymentInput.is(':checked')) {
          _this.$container.find('.registration-step4-deposit-required-radio').prop('disabled', false);
          _this.$container.find('.registration-step4-deposit-required-radio').closest('.btn').removeClass('disabled');
          
        } else {
          _this.$container.find('.registration-step4-deposit-required-radio').prop('disabled', true);
          _this.$container.find('.registration-step4-deposit-required-radio').closest('.btn').addClass('disabled'); 
        }   
        
        if ($paymentInput.is(':checked') && paymentDepositRequired === '1') {
          _this.$container.find('#registration-step4-storno-days-cbx').prop('disabled', false);
          _this.$container.find('#registration-step4-storno-days-cbx').closest('.form-check').removeClass('disabled');   
          _this.$container.find('#registration-step3-pricelist-storno-days-input').prop('disabled', false);
          
        } else {
          _this.$container.find('#registration-step4-storno-days-cbx').prop('disabled', true);
          _this.$container.find('#registration-step4-storno-days-cbx').closest('.form-check').addClass('disabled');   
          _this.$container.find('#registration-step3-pricelist-storno-days-input').prop('disabled', true);
        }
        
        return _this;
    },
    
    changePaymentGuaranteeRequired: function changePaymentGuaranteeRequired() {
        var _this = this;
     
        var paymentGuaranteeRequired = _this.$container.find('.registration-step4-guarantee-required-radio:checked').val(); 
        
        if (paymentGuaranteeRequired === '1') {
          _this.$container.find('.registration-step4-guarantee-types').prop('disabled', false);
          _this.$container.find('.registration-step4-guarantee-types').closest('.form-check').removeClass('disabled'); 
        } else {
          _this.$container.find('.registration-step4-guarantee-types').prop('disabled', true);
          _this.$container.find('.registration-step4-guarantee-types').closest('.form-check').addClass('disabled'); 
        } 
        
        return _this;
    },
    
    pricelistitemsSort: function (a, b) {
      return ($(b).data('interval_sort')) < ($(a).data('interval_sort')) ? 1 : -1;
    },
    
    changePricelistIntervalSet: function changePricelistIntervalSet() {
        var _this = this;
        
        var pricelistColumnsList = [];
        
        var $pricesIntervalsInputs = _this.$container.find('.registation-step4-pricelist-interval:checked').sort(this.pricelistitemsSort); 
        var paymentGuaranteeRequired = _this.$container.find('.registration-step4-guarantee-required-radio:checked').val();             
        
        pricelistColumnsList.push({ data: 'title', type: 'text', title: services.get('translator').trans('BColumnProductTitle'), source: [], readOnly: true });
        
        $pricesIntervalsInputs.each(function (index) {
            if ($(this).val() !== '') {
              pricelistColumnsList.push({ data: 'price_' + $(this).val(), type: 'numeric', title: $(this).data('interval_title'), source: [] });
            }  
        });
        
        if (paymentGuaranteeRequired === '1') {
            pricelistColumnsList.push({ data: 'price_guarantee', type: 'numeric', title: services.get('translator').trans('BColumnGuaranteePrice'), source: [] });
        }
        
        if ($pricesIntervalsInputs.val() === 'h4') {
           _this.$container.find('.registation-step4-pricelist-interval[value=hh]').prop('checked', false).prop('disabled', true);
        } else {
           _this.$container.find('.registation-step4-pricelist-interval[value=hh]').prop('disabled', false);
        }
        
        bulkEditItems.bulkEditTable.setting.columns = pricelistColumnsList;
        bulkEditItems.bulkEditTable.handsontable.updateSettings({ columns: pricelistColumnsList });
        
        bulkEditItems.bulkEditTable.updateSetting(bulkEditItems.bulkEditTable.setting.columns);
        
        return _this;
    },
    
    changePricelistMultidaysSet: function changePricelistMultidaysSet() {
        var _this = this;        

        var multidaysEnabled = _this.$container.find('.registation-step4-pricelist-multidays:checked').val();             
        
        if (multidaysEnabled === '1') {
            _this.$container.find('.registation-step4-pricelist-interval-d1').prop('checked', true);
            _this.changePricelistIntervalSet(); 
        }
        
        return _this;
    },
    
    changeSettingsColorSchema: function changeSettingsColorSchema() {
        var _this = this; 
        
        var custval = _this.$container.find('input.customization-color-preview__radio:checked').val();
        
        var srcurl = _this.$container.find('.customization-color-thumbs img').data('url_template');
        _this.$container.find('.customization-color-thumbs img').attr('src', srcurl.replace('#ID#', custval));
        
        return _this;
    },
    
    //**************************************************************************    

    init: function init(initPrevalidate, step) {
        var _this = this;

        _this.$container = $('#' + _this.containerID);
        _this.step = step;      
        _this.registerCallbacks();

        _this.products = new RegistrationProducts(_this.$container);
        _this.paramsDefinition = new RegistrationParamsDefinition(_this.$container);
        _this.itemsDefinition = new RegistrationItemsDefinition(_this.$container);

        if (_this.$container.find('.opening-hours-wrapper').length) {
            new OpeningHours(_this.$container.find('.opening-hours-wrapper'));
        } 
            
        //enable validation
        _this.$container.submit(function () {
            $('input.form-control-has-validation').trigger('validate');   
            var validationResults = $.regula('validate');                          
            return validationResults.length === 0;       
         });
         
         _this.changeAccountReservationKind(_this.$container.find('input[name=reservation_kind]:checked').val());
         
         if (initPrevalidate === true) {        
            $(document).ready(function () {     
              $('input.form-control-has-validation').trigger('validate'); 
            });                      
         } 
        
        if (_this.step === 4) { 
          _this.changePaymentOnlineSelection(); 
          _this.changePaymentGuaranteeRequired();
        } 
        
        return _this;
    }
});
